
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../Loading/Spinner';
import { iDataProyectoPorUsuario } from '../../interfaces/iDataProyectoPorUsuario';
import { useProjectsContext } from '../../context/Projects/ProjectContext';
import TablaPlanificacionesPorUsuario from './TablaPlanificacionesPorUsuario';
import { TablaPlanificacionesPorOrganizacion } from './TablaPlanificacionesPorOrganizacion';

function MyProjects() {
  const { isLoading, subscribeToNewResults } = useProjectsContext();  
  const navigate = useNavigate();

  const handleEditarProyecto = (data: iDataProyectoPorUsuario) => {
    if (typeof data.propuesta === 'string') {
      data.propuesta = JSON.parse(data.propuesta);
    }
    const objectKeys = Object.keys(data.propuesta);
    // Se suscribe a actualizaciones para el proyecto seleccionado
    subscribeToNewResults(data.proyectoId);
    navigate(`/asistente/detalleproyecto/${data.proyectoId}`, {
      state: { proyecto: data, keys: objectKeys },
    });
  };

  return (
    <>
      {isLoading && <Spinner msg={'Cargando resultados por favor espere...'} />}
      {!isLoading && (
        <>
          {/* La tabla de recursos del usuario utiliza el contexto para obtener los proyectos */}
          <TablaPlanificacionesPorUsuario handleVerProyecto={handleEditarProyecto} />
          <TablaPlanificacionesPorOrganizacion handleVerProyecto={handleEditarProyecto} />
        </>
      )}
    </>
  );
}

export default MyProjects;
